{
    "NAME": "TelModuleStatusListLanguage",
    "TelModuleStatusList_Title": "Telephone Module Status",
    "TelModuleStatusList_Column_TelSys": "Telephony Server",
    "TelModuleStatusList_Column_ClassName": "Class Name",
    "TelModuleStatusList_Column_Type": "Type",
    "TelModuleStatusList_Column_Version": "Version",
    "TelModuleStatusList_Column_Status": "Status",
    "TelModuleStatusList_Column_LastError": "Last Error",
    "TelModuleStatusList_Column_LastErrorDateTime": "Last Error Date/Time",
    "TelModuleStatusList_Empty": "No telephone module status items are available."
}
